<template>
    <Container fluid>
        <v-row dense>
            <v-col
                v-for="carHistoryItem in carHistory"
                :key="carHistoryItem.id"
                cols="12"
            >
                <OrderHistoryItem
                    :order="carHistoryItem"
                    :car="carState.cars[carHistoryItem.carId]"
                />
            </v-col>
        </v-row>
    </Container>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import Container from '@/components/Vuetify/Container'
    import OrderHistoryItem from '@/components/app/personal/order/OrderHistoryItem'

    export default {
        name: 'HistoryScreen',

        components: {
            Container,
            OrderHistoryItem,
        },

        computed: {
            ...mapState('car', {
                carState: state => state,
            }),

            ...mapGetters({
                carHistory: 'carHistory/getCarHistory',
            }),
        },

        mounted() {
            this.$store.dispatch('car/fetch')
            this.$store.dispatch('carHistory/fetch')
        },
    }
</script>
